import { render, staticRenderFns } from "./Finiquitos.vue?vue&type=template&id=24cd46dc&scoped=true"
import script from "./Finiquitos.vue?vue&type=script&lang=js"
export * from "./Finiquitos.vue?vue&type=script&lang=js"
import style0 from "./Finiquitos.vue?vue&type=style&index=0&id=24cd46dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd46dc",
  null
  
)

export default component.exports